import { DEFAULTAVATAR, getReqClosedCasesCountApi } from 'Constants';
import { Context } from 'Context/Context';
import React, { useContext, useEffect, useState } from 'react';
import { FaSackDollar } from 'react-icons/fa6';
import { MdVerified } from "react-icons/md";

function ProfilePicWithDetails({currentProf, picSize}) {
  const {makeApiCallFunc} = useContext(Context);
  const [requestedNum, setRequestedNum] = useState(0);
  const [represents, setRepresents] = useState('');
  const [closedNumb, setClosedNumb] = useState(0);
  const [responseReceived, setResponseReceived] = useState(false);

  useEffect(() => {
    setResponseReceived(false);
    let stale = false;   // ignore a reply for a profile we've already moved past

    if(currentProf?._id)
    {
    makeApiCallFunc(getReqClosedCasesCountApi,
      {
          userId: currentProf?._id,
          isUserAssistant: currentProf?.isUserAssistant
      },
      ({data}) =>
      {
        if (stale) return;
        setClosedNumb(data?.closed)
        setRequestedNum(data?.requested)
        setResponseReceived(true);
        setRepresents(data?.profName ? data?.profName : null);
      },
      (data) => {
          console.log("getcasescountapi error")
          setResponseReceived(true);
          }
          ,
          null,
        true
      )
    }
    return () => { stale = true; };
  }, [currentProf?._id])

  const large = picSize === 'l';
  const subtitle = [currentProf?.legalType, currentProf?.company].filter(Boolean).join(" · ");

  return (
    <div className={'flex flex-col items-center text-center font-plexsans ' + (large ? 'p-2' : 'p-4')}>
        <div className='relative'>
        {
          currentProf?.isUserFunder ?
            <div className={'flex items-center justify-center rounded-full bg-[rgba(138,98,49,.1)] ' + (large ? 'w-[100px] h-[100px]' : 'w-16 h-16')}>
              <FaSackDollar className={'text-tan ' + (large ? 'h-10 w-10' : 'h-7 w-7')}/>
            </div>
            :
            <>
             <img
              className={'rounded-full object-cover border border-[rgba(20,33,61,.1)] ' + (large ? 'w-[100px] h-[100px]' : 'w-16 h-16')}
              src={currentProf?.profilePic ? currentProf?.profilePic : DEFAULTAVATAR} alt="Preview" />
              <div className={'absolute bg-ivory rounded-full p-0.5 ' + (large ? 'bottom-0 right-0' : '-bottom-0.5 -right-0.5')}>
                  <MdVerified className={'text-tan ' + (large ? 'h-6 w-6' : 'h-4 w-4')} />
              </div>
            </>
        }
        </div>

        <div className={'mt-3 font-semibold text-navy font-spectral ' + (large ? 'text-xl' : 'text-[15px]')}>
          {currentProf?.firstName} {currentProf?.lastName}
          {currentProf?.isUserAssistant && <span className='text-[12px] text-[rgba(20,33,61,.5)] font-normal'>&nbsp;(Assistant)</span>}
        </div>

        {subtitle &&
          <div className='mt-1 text-[13px] text-[rgba(20,33,61,.55)]'>
            {subtitle}
          </div>
        }

        {/* activity line appears once loaded - no spinner left hanging under the name */}
        {!currentProf?.isUserAssistant && responseReceived &&
          <div className='mt-2 text-[12px] text-[rgba(20,33,61,.45)]'>
            {requestedNum ? requestedNum : 0} requests sent &middot; {closedNumb ? closedNumb : 0} closed
          </div>
        }
    </div>
  )
}

export default ProfilePicWithDetails
